import { useFormaliteService } from '@europrocurement/l2d-domain';
import { DossierOpenSearchJsonldOpensearchDossierOfferRead } from '@europrocurement/l2d-domain/openApi/ApiFormalite';

export type DossierOffer = DossierOpenSearchJsonldOpensearchDossierOfferRead &
    Record<string, unknown>;

const useDossierOffer = () => {
    const { dossierOpenSearchApi } = useFormaliteService();
    let searchTimeout: number | undefined;

    const searchDossierOffer = (term: string): Promise<Array<DossierOffer>> =>
        new Promise((resolve, reject) => {
            clearTimeout(searchTimeout);
            const requestParameters = { q: term || undefined };

            searchTimeout = setTimeout(() => {
                dossierOpenSearchApi
                    .apiOpensearchOffersGetCollection(requestParameters)
                    .then((res) => resolve(res.data['hydra:member'] as Array<DossierOffer>))
                    .catch(() => reject());
            }, 300);
        });

    return { searchDossierOffer };
};

export default useDossierOffer;
